(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 20394:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(91635);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 91635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var src_components_layout_LayoutAdapter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39891);
/* harmony import */ var src_components_navigation_NextLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50752);
/* harmony import */ var hooks_useRouter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98377);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33850);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14531);










var NotFoundPage = function() {
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var router = (0,hooks_useRouter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var errorPageMetadata = {
        pageTitle: "404 Page not found",
        pageDescription: "The requested page could not be found.",
        canonicalTag: "https://deepstash.com/404",
        robotsTag: "noindex"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_layout_LayoutAdapter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        pageMetadata: errorPageMetadata,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
            flexDirection: {
                base: "column",
                lg: "row"
            },
            mt: {
                base: "0",
                lg: "125px"
            },
            align: "center",
            justifyContent: "center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                    flexDirection: "column",
                    w: "50%",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, {
                            fontSize: "60px",
                            fontWeight: "300",
                            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                            children: "404"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                            mb: "10px"
                        }, theme__WEBPACK_IMPORTED_MODULE_6__/* .typography.articleTitle */ .c.articleTitle), {
                            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                            children: [
                                router.asPath.includes("/u/") ? "User" : "Page",
                                " Not Found"
                            ]
                        })),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, {
                            mb: "60px",
                            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                            children: "The page you are looking for was moved, removed, renamed or may have never existed."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_navigation_NextLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            href: "/",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Button, {
                                w: "150px",
                                px: "20px",
                                backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].primary.default,
                                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].surface,
                                _hover: undefined,
                                _active: {
                                    backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textMuted
                                },
                                _focus: {
                                    outline: "none"
                                },
                                borderRadius: 20,
                                outline: "none",
                                mr: "20px",
                                mb: "20px",
                                fontSize: "16px",
                                children: "Go Home"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: (0,utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .missingImage */ .gW)(colorMode),
                    width: "300px"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (NotFoundPage);


/***/ }),

/***/ 46039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);






var BaseCard = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function(_param, ref) {
    var children = _param.children, /**
       * True if we should draw a shadow underneath
       * @default false
       */ hasShadow = _param.hasShadow, /**
       * True if the card should have a hover effect
       * @default false
       */ hasHoverEffect = _param.hasHoverEffect, _cardSize = _param./**
       * Used to hint the size of the card to the component,
       * to better tailor the shadow and hover effect, if
       * applied.
       *
       * It only works on desktop devices.
       * @default lg
       */ cardSize, cardSize = _cardSize === void 0 ? "lg" : _cardSize, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "hasShadow",
        "hasHoverEffect",
        "cardSize"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var isDesktopView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsDesktopView)();
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(cardSize === "lg" ? 16 : 8), shadowSize = _$ref.current;
    var _backgroundColor, _$ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        width: "100%",
        height: "100%",
        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
        borderRadius: "1rem",
        position: "relative",
        transition: "all 0.3s cubic-bezier(.11,.57,.44,.8)",
        overflow: "hidden",
        boxShadow: hasShadow ? "0px ".concat(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(shadowSize), " 0px 0px ").concat(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].underground) : ""
    }, props), {
        backgroundColor: (_$ref1 = (_backgroundColor = props.backgroundColor) !== null && _backgroundColor !== void 0 ? _backgroundColor : props.bgColor) !== null && _$ref1 !== void 0 ? _$ref1 : deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].top,
        _hover: hasHoverEffect && isDesktopView ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props._hover), {
            transform: "translateY(-".concat(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(shadowSize / 4), ")"),
            boxShadow: "0px ".concat(hasShadow ? deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(shadowSize * 1.5) : deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(shadowSize / 4), " 0px 0px ").concat(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].underground, "CC")
        }) : (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props._hover),
        children: children
    }));
});
/* harmony default export */ __webpack_exports__["Z"] = (BaseCard);


/***/ }),

/***/ 32306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63069);
/* harmony import */ var utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51599);
/* harmony import */ var utils_StringUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94030);









var IdeaCounter = function(_param) {
    var ideaCount = _param.ideaCount, isDraft = _param.isDraft, readCount = _param.readCount, totalReadCount = _param.totalReadCount, totalSaveCount = _param.totalSaveCount, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "ideaCount",
        "isDraft",
        "readCount",
        "totalReadCount",
        "totalSaveCount"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var ideaNoun = isDraft ? utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_4__/* ["default"].draft.toLowerCase */ .Z.draft.toLowerCase() : utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_4__/* ["default"].idea.toLowerCase */ .Z.idea.toLowerCase();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        gridGap: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XS.rem,
        alignItems: "center",
        flexShrink: 0,
        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary
    }, props), {
        children: [
            readCount === ideaCount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.CheckFillSvg, {
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.success
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, {
                children: [
                    ideaCount,
                    " ",
                    (0,utils_StringUtils__WEBPACK_IMPORTED_MODULE_5__/* .getSingularOrPlural */ .Lo)(ideaCount, ideaNoun, ideaNoun + "s")
                ]
            }),
            readCount !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    "\xb7",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, {
                        children: [
                            readCount,
                            " read"
                        ]
                    })
                ]
            }),
            (totalReadCount || totalSaveCount) && "\xb7",
            totalReadCount !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, {
                children: [
                    totalReadCount === 0 ? "No" : (0,utils_global__WEBPACK_IMPORTED_MODULE_3__/* .numberFormatter */ .V2)(totalReadCount),
                    " ",
                    (0,utils_StringUtils__WEBPACK_IMPORTED_MODULE_5__/* .getSingularOrPlural */ .Lo)(totalReadCount, "read", "reads")
                ]
            }),
            totalSaveCount !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, {
                children: [
                    totalSaveCount === 0 ? "No" : (0,utils_global__WEBPACK_IMPORTED_MODULE_3__/* .numberFormatter */ .V2)(totalSaveCount),
                    " ",
                    "saves"
                ]
            })
        ]
    }), ideaCount);
};
/* harmony default export */ __webpack_exports__["Z"] = (IdeaCounter);


/***/ }),

/***/ 93240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14531);







var ProgressBar = function(_param) {
    var _direction = _param.direction, direction = _direction === void 0 ? "horizontal" : _direction, initialCurrentValue = _param.currentValue, totalValue = _param.totalValue, showTag = _param.showTag, autoplayDuration = _param.autoplayDuration, isPadded = _param.isPadded, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "direction",
        "currentValue",
        "totalValue",
        "showTag",
        "autoplayDuration",
        "isPadded"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(autoplayDuration ? 0 : initialCurrentValue), currentValue = ref[0], setCurrentValue = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setCurrentValue(initialCurrentValue);
    }, [
        initialCurrentValue
    ]);
    var getFillInPercentage = function() {
        if (isPadded) {
            return currentValue === 0 ? 0 : currentValue === totalValue ? 100 : Math.min(Math.max(currentValue / totalValue, 0.1), 0.9) * 100;
        } else {
            return currentValue / totalValue * 100;
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        position: "relative",
        bgColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].underground
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
            borderRadius: props.borderRadius,
            height: direction === "horizontal" ? "100%" : "".concat(getFillInPercentage(), "%"),
            width: direction === "horizontal" ? "".concat(getFillInPercentage(), "%") : "100%",
            pos: "absolute",
            left: 0,
            top: 0,
            bgColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.success,
            transition: "".concat(autoplayDuration !== null && autoplayDuration !== void 0 ? autoplayDuration : utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .TRANSITION_TIME */ .aV * 1000, "ms linear"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                height: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(20),
                transform: showTag ? "" : "scaleY(0)",
                transition: "".concat(utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .TRANSITION_TIME */ .aV, "s ease"),
                width: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(20),
                pos: "absolute",
                right: 0,
                top: showTag ? "-".concat(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(18)) : 0,
                borderRadius: "".concat(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem, " ").concat(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem, " 0 0"),
                bgColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.success,
                justifyContent: "center",
                // We want it to be white for both themes
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.light.textInverted,
                style: {
                    fontWeight: "bold",
                    fontSize: "0.875rem"
                },
                pt: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(1),
                zIndex: 1000,
                overflow: "hidden",
                children: currentValue
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ProgressBar);


/***/ }),

/***/ 28953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$W": function() { return /* binding */ BORDER_RADIUS_M; },
/* harmony export */   "$i": function() { return /* binding */ HEADER_SPACE; },
/* harmony export */   "W5": function() { return /* binding */ PAGE_PADDING; },
/* harmony export */   "dD": function() { return /* binding */ CONTENT_PADDING_M; },
/* harmony export */   "nB": function() { return /* binding */ BORDER_RADIUS_L; },
/* harmony export */   "uU": function() { return /* binding */ DROPDOWN_WIDTH; },
/* harmony export */   "vl": function() { return /* binding */ IDEA_WIDTH; }
/* harmony export */ });
/* unused harmony exports LEFT_SIDE_WIDTH, RIGHT_SIDE_WIDTH, FEED_WIDTH, SAVED_IDEAS_WIDTH, ARTICLE_WIDTH, LOGGED_OUT_AD_WIDTH, CAROUSEL_WIDTH, CAROUSEL_ITEM_WIDTH, CAROUSEL_ITEM_HEIGHT, KNOWLEDGE_CARD_WIDTH, KNOWLEDGE_CARD_HEIGHT, SMALL_INSIGHT_CARD_WIDTH, SMALL_INSIGHT_CARD_HEIGHT, INSIGHT_PREVIEW_WIDTH_S, INSIGHT_PREVIEW_WIDTH_L, INSIGHT_PREVIEW_HEiGHT_S, INSIGHT_PREVIEW_HEiGHT_L, IDEA_TITLE_INPUT_WIDTH, PREVIEW_IDEA_WIDTH, PREVIEW_IDEA_HEIGHT, HEADER_WIDTH, HEADER_WIDTH_SCROLLING, HEADER_WIDTH_SHORT, HEADER_WIDTH_SHORT_SCROLLING, TOAST_WIDTH, BORDER_RADIUS_S, BORDER_RADIUS_MAX, MARGIN_S, MARGIN_M, MARGIN_L, CONTENT_PADDING_S, CONTENT_PADDING_L, CURTAIN_THRESHOLD, TITLE_MAX_LEN */
// SAVED IDEAS HEIGHTS
var HEADER_SPACE = 80;
// ------------------------
// LAYOUT WIDTHS
var SIDE_MENU_WIDTH = 300;
var LEFT_SIDE_WIDTH = (/* unused pure expression or super */ null && (SIDE_MENU_WIDTH));
var RIGHT_SIDE_WIDTH = (/* unused pure expression or super */ null && (SIDE_MENU_WIDTH));
var FEED_WIDTH = 735;
var CONTENT_WIDTH = 870;
var SAVED_IDEAS_WIDTH = (/* unused pure expression or super */ null && (CONTENT_WIDTH));
var ARTICLE_WIDTH = (/* unused pure expression or super */ null && (CONTENT_WIDTH));
var DROPDOWN_WIDTH = 280;
var LOGGED_OUT_AD_WIDTH = 320;
// ------------------------
// COMPONENT SIZES
// FEED
var CAROUSEL_WIDTH = 870;
var CAROUSEL_ITEM_WIDTH = 400;
var CAROUSEL_ITEM_HEIGHT = 400;
// KNOWLEDGE CARDS
var KNOWLEDGE_CARD_WIDTH = 270;
var KNOWLEDGE_CARD_HEIGHT = 270;
// INSIGHT CARDS
var SMALL_INSIGHT_CARD_WIDTH = 130;
var SMALL_INSIGHT_CARD_HEIGHT = 125;
var INSIGHT_PREVIEW_WIDTH_S = 164;
var INSIGHT_PREVIEW_WIDTH_L = 265;
var INSIGHT_PREVIEW_HEiGHT_S = 129;
var INSIGHT_PREVIEW_HEiGHT_L = 350;
// SAVED IDEAS
var IDEA_WIDTH = 415;
var IDEA_TITLE_INPUT_WIDTH = IDEA_WIDTH - 80;
var PREVIEW_IDEA_WIDTH = 279;
var PREVIEW_IDEA_HEIGHT = 279;
var HEADER_OVERFLOW = 30;
var HEADER_OVERFLOW_SCROLLING = 15;
var HEADER_WIDTH = (/* unused pure expression or super */ null && (CAROUSEL_WIDTH));
var HEADER_WIDTH_SCROLLING = CAROUSEL_WIDTH + 2 * HEADER_OVERFLOW_SCROLLING;
var HEADER_WIDTH_SHORT = FEED_WIDTH + 2 * HEADER_OVERFLOW;
var HEADER_WIDTH_SHORT_SCROLLING = FEED_WIDTH + 2 * HEADER_OVERFLOW;
// TOAST
var TOAST_WIDTH = 600;
// ------------------------
// STYLING
var BORDER_RADIUS_S = "0.5rem";
var BORDER_RADIUS_M = "1rem";
var BORDER_RADIUS_L = "1.25rem";
var BORDER_RADIUS_MAX = 1000;
var MARGIN_S = 10;
var MARGIN_M = 15;
var MARGIN_L = 25;
// PADDING
var CONTENT_PADDING_S = 10;
var CONTENT_PADDING_M = 15;
var CONTENT_PADDING_L = 20;
var PAGE_PADDING = 25;
// ------------------------
// MISC
var CURTAIN_THRESHOLD = 1500;
var TITLE_MAX_LEN = 90;


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 70131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ObserverMap = new Map();
var RootIds = new WeakMap();
var rootId = 0;
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(function (key) {
    return options[key] !== undefined;
  }).map(function (key) {
    return key + "_" + (key === 'root' ? getRootId(options.root) : options[key]);
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  var id = optionsToId(options);
  var instance = ObserverMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    var elements = new Map();
    var thresholds;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        var inView = entry.isIntersecting && thresholds.some(function (threshold) {
          return entry.intersectionRatio >= threshold;
        }); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(function (callback) {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id: id,
      observer: observer,
      elements: elements
    };
    ObserverMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options) {
  if (options === void 0) {
    options = {};
  }

  if (!element) return function () {}; // An observer with the same options can be reused, so lets use this fact

  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements; // Register the callback listener for this element


  var callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements["delete"](element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      ObserverMap["delete"](id);
    }
  };
}

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


var InView = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InView, _React$Component);

  function InView(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.node = null;
    _this._unobserveCb = null;

    _this.handleNode = function (node) {
      if (_this.node) {
        // Clear the old observer, before we start observing a new element
        _this.unobserve();

        if (!node && !_this.props.triggerOnce && !_this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          _this.setState({
            inView: !!_this.props.initialInView,
            entry: undefined
          });
        }
      }

      _this.node = node ? node : null;

      _this.observeNode();
    };

    _this.handleChange = function (inView, entry) {
      if (inView && _this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        _this.unobserve();
      }

      if (!isPlainChildren(_this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        _this.setState({
          inView: inView,
          entry: entry
        });
      }

      if (_this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        _this.props.onChange(inView, entry);
      }
    };

    _this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
    return _this;
  }

  var _proto = InView.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unobserve();
    this.node = null;
  };

  _proto.observeNode = function observeNode() {
    if (!this.node || this.props.skip) return;
    var _this$props = this.props,
        threshold = _this$props.threshold,
        root = _this$props.root,
        rootMargin = _this$props.rootMargin,
        trackVisibility = _this$props.trackVisibility,
        delay = _this$props.delay;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold: threshold,
      root: root,
      rootMargin: rootMargin,
      // @ts-ignore
      trackVisibility: trackVisibility,
      // @ts-ignore
      delay: delay
    });
  };

  _proto.unobserve = function unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  };

  _proto.render = function render() {
    if (!isPlainChildren(this.props)) {
      var _this$state = this.state,
          inView = _this$state.inView,
          entry = _this$state.entry;
      return this.props.children({
        inView: inView,
        entry: entry,
        ref: this.handleNode
      });
    }

    var _this$props2 = this.props,
        children = _this$props2.children,
        as = _this$props2.as,
        tag = _this$props2.tag,
        props = _objectWithoutPropertiesLoose(_this$props2, ["children", "as", "tag", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView"]);

    return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(as || tag || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  };

  return InView;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
InView.displayName = 'InView';
InView.defaultProps = {
  threshold: 0,
  triggerOnce: false,
  initialInView: false
};

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      threshold = _ref.threshold,
      delay = _ref.delay,
      trackVisibility = _ref.trackVisibility,
      rootMargin = _ref.rootMargin,
      root = _ref.root,
      triggerOnce = _ref.triggerOnce,
      skip = _ref.skip,
      initialInView = _ref.initialInView;

  var unobserve = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();

  var _React$useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    inView: !!initialInView
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var setRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (node) {
    if (unobserve.current !== undefined) {
      unobserve.current();
      unobserve.current = undefined;
    } // Skip creating the observer


    if (skip) return;

    if (node) {
      unobserve.current = observe(node, function (inView, entry) {
        setState({
          inView: inView,
          entry: entry
        });

        if (entry.isIntersecting && triggerOnce && unobserve.current) {
          // If it should only trigger once, unobserve the element after it's inView
          unobserve.current();
          unobserve.current = undefined;
        }
      }, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold,
        // @ts-ignore
        trackVisibility: trackVisibility,
        // @ts-ignore
        delay: delay
      });
    }
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, root, rootMargin, triggerOnce, skip, trackVisibility, delay]);
  /* eslint-disable-next-line */

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!unobserve.current && state.entry && !triggerOnce && !skip) {
      // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView
      });
    }
  });
  var result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (InView)));

//# sourceMappingURL=react-intersection-observer.m.js.map


/***/ }),

/***/ 45363:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
__webpack_unused_export__ = ({ value: true });
exports.h6 = __webpack_unused_export__ = __webpack_unused_export__ = void 0;
var json_ld_1 = __webpack_require__(82342);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return json_ld_1.helmetJsonLdProp; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return json_ld_1.JsonLd; } });
Object.defineProperty(exports, "h6", ({ enumerable: true, get: function () { return json_ld_1.jsonLdScriptProps; } }));


/***/ }),

/***/ 82342:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.helmetJsonLdProp = exports.jsonLdScriptProps = exports.JsonLd = void 0;
const React = __webpack_require__(67294);
function JsonLd(props) {
    return React.createElement("script", Object.assign({}, jsonLdScriptProps(props.item, props)));
}
exports.JsonLd = JsonLd;
function jsonLdScriptProps(item, options = {}) {
    return {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(item, safeJsonLdReplacer, options.space),
        },
    };
}
exports.jsonLdScriptProps = jsonLdScriptProps;
function helmetJsonLdProp(item, options = {}) {
    return {
        type: "application/ld+json",
        innerHTML: JSON.stringify(item, safeJsonLdReplacer, options.space),
    };
}
exports.helmetJsonLdProp = helmetJsonLdProp;
const ESCAPE_ENTITIES = Object.freeze({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&apos;",
});
const ESCAPE_REGEX = new RegExp(`[${Object.keys(ESCAPE_ENTITIES).join("")}]`, "g");
const ESCAPE_REPLACER = (t) => ESCAPE_ENTITIES[t];
/**
 * A replacer for JSON.stringify to strip JSON-LD of illegal HTML entities
 * per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
 */
const safeJsonLdReplacer = (() => {
    // Replace per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
    // Solution from https://stackoverflow.com/a/5499821/864313
    return (_, value) => {
        switch (typeof value) {
            case "object":
                // Omit null values.
                if (value === null) {
                    return undefined;
                }
                return value; // JSON.stringify will recursively call replacer.
            case "number":
            case "boolean":
            case "bigint":
                return value; // These values are not risky.
            case "string":
                return value.replace(ESCAPE_REGEX, ESCAPE_REPLACER);
            default: {
                // We shouldn't expect other types.
                isNever(value);
                // JSON.stringify will remove this element.
                return undefined;
            }
        }
    };
})();
// Utility: Assert never
function isNever(_) { }


/***/ }),

/***/ 40872:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}


/***/ }),

/***/ 51351:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _throw; }
/* harmony export */ });
function _throw(e) {
    throw e;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [296,9891,9774,2888,179], function() { return __webpack_exec__(20394); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);